import {useIsCheckoutPage} from '@aboutyou/router';
import {GuestUserState, useUser} from '@aboutyou/user';
import {useEffect} from 'react';

export const GuestCheckoutSessionRemover = () => {
  const isCheckoutPage = useIsCheckoutPage();
  const {data, updateCache} = useUser();

  useEffect(() => {
    if (
      !isCheckoutPage &&
      data &&
      'guestToken' in data &&
      (data as GuestUserState).guestToken
    ) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      updateCache({
        ...data,
        checkoutSession: data?.checkoutSession ?? null,
        guestToken: undefined,
      });
    }
  }, [isCheckoutPage]);

  return null;
};
